import { connect } from 'react-redux'
import { Login } from './component'


const mapStateToProps = (state, {location}) => {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.user,
    location
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

const LoginContainer: React.ComponentClass<any> = connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/login/container.ts